import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-18 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2 text-center">
          精选视频
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          热门影视内容精选推荐，点击即可观看
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer transition-all duration-200 hover:border-primary-300"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full aspect-video object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-white text-xs font-medium whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90">
                    <i className="ri-play-fill text-2xl text-white"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500">{item.category}</span>
                  <span className="text-xs text-foreground-400">{item.views}次播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}